import React from 'react';
import { Button } from 'new/elements/Button';
import { Send as SendIcon, Transform as TransformIcon } from '@mui/icons-material';
import { Stack, Tooltip } from '@mui/material';
import { ROUTE_MY_DATA_SETS } from 'js/constants/pathnames';
import { useHistory } from 'react-router-dom';
import styles from './Discover.module.scss';
import { ROUTE_CONNECT } from 'new/constants/pathnames';

interface NexsetActionsProps {
  id: number;
}

const Send = ({ onClick }: { onClick?: () => void }) => {
  if (!onClick) return null;
  return (
    <Tooltip title="Send to destination" arrow>
      <Button
        className={styles.nexsetAction}
        onClick={onClick}
        size="small"
        color="inherit"
        endIcon={<SendIcon />}
        variant="outlined"
      >
        Send
      </Button>
    </Tooltip>
  );
};

const Transform = ({ onClick }: { onClick?: () => void }) => {
  if (!onClick) return null;
  return (
    <Tooltip title="Transform this nexset to generate a new one" arrow>
      <Button
        className={styles.nexsetAction}
        onClick={onClick}
        size="small"
        color="inherit"
        endIcon={<TransformIcon />}
        variant="outlined"
      >
        Transform
      </Button>
    </Tooltip>
  );
};

export const NexsetActions = (props: NexsetActionsProps) => {
  const { id } = props;
  const history = useHistory();
  const onClickNew = () => {
    history.push(`${ROUTE_CONNECT}${ROUTE_MY_DATA_SETS}/${id}/new`);
  };

  const onClickSend = () => {
    history.push(
      `${ROUTE_CONNECT}${ROUTE_MY_DATA_SETS}/${id}/send?from=${history.location.pathname}`,
    );
  };
  return (
    <Stack direction="row" alignItems="center" gap="16px">
      <Transform onClick={onClickNew} />
      <Send onClick={onClickSend} />
    </Stack>
  );
};

NexsetActions.Send = Send;
NexsetActions.Transform = Transform;
